import React from 'react'

import { connect } from 'react-redux'
import RaisedButton from 'material-ui/RaisedButton'

import ClockUtils from '../common/ClockUtils'
import EventCardIndicators from '../common/EventCardIndicators'
import JobStatus from 'infra/JobStatus'

class BottomCard extends React.PureComponent {

  constructor(props) {
    super(props)
    this.state = {
      clockData: {}
    }
  }

  componentWillMount() {
    const clockData = ClockUtils.getClockData(this.props.eventInfo, this.props.dateStr)
    this.setState({ clockData })
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.eventInfo !== this.props.eventInfo || nextProps.dateStr !== this.props.dateStr) {
      const clockData = ClockUtils.getClockData(nextProps.eventInfo, nextProps.dateStr)
      this.setState({ clockData })
    }
  }

  goToJobScreen = () => {
    this.props.dispatch({
      type: 'UI_DIALOG',
      label: 'JOB_SCREEN',
      value: {
        jobInfo: this.props.eventInfo.commonInfo,
        dateStr: this.props.dateStr
      }
    })
  }

  getUserCalendarColor = calendarId => {
    if (this.props.userCalendarsList) {
      const calendar = this.props.userCalendarsList.find(uc => uc.id === calendarId)
      if (calendar) {
        return calendar.backgroundColor
      }
    }
    return 'gray'
  }

  render() {
    const eventCommonInfo = this.props.eventInfo.commonInfo
    const displayName = eventCommonInfo.modules.displayName.value
    const backgroundColor = this.state.clockData.status === JobStatus.COMPLETED ? '#527da3': '#dbefff'
    const fontColor = this.state.clockData.status === JobStatus.COMPLETED ? 'white' : '#757575'
    const showSource = eventCommonInfo.source && eventCommonInfo.source.value === 'gcal'
    const sourceColor = showSource
      ? this.getUserCalendarColor(eventCommonInfo.source.calendarId)
      : null
    return (
      <RaisedButton
        className='JobCard'
        disableTouchRipple={true}
        style={styles.container}
        buttonStyle={styles.buttonContainer}
        backgroundColor={backgroundColor}
        onTouchTap={this.goToJobScreen}>
        <div style={styles.content}>
          <div style={styles.displayName(fontColor)}>{ displayName }</div>
          <EventCardIndicators
            jobStatus={this.state.clockData.status}
            showSource={showSource}
            sourceColor={sourceColor} />
        </div>
      </RaisedButton>
    )
  }

}

const styles = {
  container: {
    marginTop: 16,
    marginBottom: 16,
    marginLeft: 8,
    marginRight: 8,
    width: 160,
    height: 40,
    flexGrow: 0,
    flexShrink: 0
  },
  content: {
    display: 'flex',
    justifyContent: 'space-between',
    marginLeft: 8,
    marginRight: 4
  },
  buttonContainer: {
    width: 160,
    height: 40,
    border: '1px solid #527da3',
    borderRadius: 3
  },
  displayName: fontColor => ({
    color: fontColor,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    display: 'block',
    fontSize: 14
  })
}

export default connect(state => ({ userCalendarsList: state.userCalendars.list }))(BottomCard)



// WEBPACK FOOTER //
// ./src/schedule/map/BottomCard.js